import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const Socials = ({ imgSrc }) => (
  <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 10 }, py: { xs: 6, md: 10 }, bgcolor: "#fff" }}>
    <Box sx={{ position: "relative", width: "100%", overflow: "hidden" }}>
      <Box
        component="img"
        src={imgSrc}
        alt="StrandzByDee"
        sx={{ width: "100%", display: "block", objectFit: "cover", maxHeight: { xs: 320, md: 480 } }}
      />
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.05) 60%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
          pb: { xs: 4, md: 6 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{ fontSize: { xs: 11, md: 12 }, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.7)", mb: 0.75 }}
        >
          Follow us on Instagram
        </Typography>
        <Typography
          component="a"
          href="https://www.instagram.com/strandzbydee"
          target="_blank"
          rel="noreferrer"
          sx={{
            fontSize: { xs: 22, md: 30 },
            fontWeight: 300,
            letterSpacing: "-0.02em",
            color: "#fff",
            textDecoration: "none",
            borderBottom: "1px solid rgba(255,255,255,0.5)",
            pb: 0.5,
            "&:hover": { borderColor: "#fff" },
          }}
        >
          @StrandzByDee
        </Typography>
      </Box>
    </Box>
  </Box>
);
